import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import AdminDashboard from '../views/AdminDashboard.vue'
import ManageUsers from '../views/ManageUsers.vue'
import UserById from '../views/UserById.vue'
import AdminProfile from '../views/AdminProfile.vue'
import Farms from '../views/Farms.vue'
import AdminFarmsById from '../views/AdminFarmsById.vue'
import AdminInvestById from '../views/AdminInvestmentById'
import AddFarm from '../views/AddFarm.vue'
import EditFarm from '../views/EditFarm.vue'
import UserDashboard from '../views/UserDashboard.vue'
import UserFarms from '../views/UserFarms.vue'
import UserFarmsById from '../views/UserFarmsById.vue'
import UserTransactions from '../views/UserTransactions.vue'
import InvestNow from '../views/InvestNow.vue'
import InvestmentById from '../views/InvestmentById.vue'
import Profile from '../views/Profile.vue'
import Notifications from '../views/Notifications.vue'
import AdminNav from '@/Layouts/AdminLayout'
import UserNav from '@/Layouts/UserLayout'
import PageNotFound from '../views/404.vue'
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  
  // admin here
  {
    path: '/dashboard/admin',
    redirect: 'dashboard',
    component: AdminNav,
    children: [
      {
        path: '/dashboard/admin',
        name: 'AdminDashboard',
        component: AdminDashboard
      },
      {
        path: '/profile/admin',
        name: 'AdminProfile',
        component: AdminProfile
      },
      {
        path: '/manageusers',
        name: 'ManageUsers',
        component: ManageUsers
      },
      {
        path: '/manageusers/:id',
        name: 'UserById',
        component: UserById
      },
      {
        path: '/admin/invest/:id',
        name: 'InvestById',
        component: AdminInvestById
      },
      {
        path: '/farms/admin',
        name: 'Farms',
        component: Farms
      },
      {
        path: '/farms/admin/:id',
        name: 'AdminFarmsById',
        component: AdminFarmsById
      },
      {
        path: '/farms/create/admin',
        name: 'AddFarm',
        component: AddFarm
      },
      {
        path: '/farms/edit',
        name: 'EditFarm',
        component: EditFarm
      },
      {
        path: '/notifications',
        name: 'Notifications',
        component: Notifications
      },
    ]
  },
  // user here
  {
    path: '/dashboard',
    redirect: 'dashboard',
    component: UserNav,
    children: [
      {
        path: '/dashboard',
        name: 'UserDashboard',
        component: UserDashboard
      },
      {
        path: '/farms',
        name: 'UserFarms',
        component: UserFarms
      },
      
      {
        path: '/farms/:id',
        name: 'UserFarmsById',
        component: UserFarmsById
      },
      {
        path: '/invest',
        name: 'InvestNow',
        component: InvestNow
      },
      {
        path: '/invest/:id',
        name: 'InvestmentById',
        component: InvestmentById
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile
      },
      {
        path: '/transactions',
        name: 'UserTransactions',
        component: UserTransactions
      },
    ]
  },
  {
    path:'*',
    name:'PageNotFound',
    component:PageNotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
